import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import HeaderMenuButton from './HeaderMenuButton';
// import {
//   Link
// } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
// import {
//   menuColor
// } from "helpers/colors";
const styles = (theme) => {
  return {};
};
class HeaderMenu extends Component {
  contructor(props) {
    this.super(props);
  }
  // _onClick(e, href) {
  //   const id = href.replace("/#", "");
  //   if(["mission"].indexOf(id) < 0) {
  //     const top = document.getElementById(id) ? document.getElementById(id).offsetTop + 10 - document.getElementById("header").offsetHeight : false;
  //     window.scroll({
  //       top,
  //       behavior: "smooth",
  //     });
  //   }
  //   if(this.props.onClick) this.props.onClick();
  // }
  render() {
    const {
      // mode,
      current,
      $$menu,
      // classes
    } = this.props;
    let gridSize = 2;
    let xsGridSize = 12;
    return (
      <React.Fragment>
        {$$menu
          .map((menu, i) => {
            gridSize = i === 0 ? 4 : 2;
            xsGridSize = i === 0 ? 12 : 6;
            return (
              <Grid item xs={xsGridSize} sm={gridSize} key={'lnk_' + i}>
                <HeaderMenuButton menu={menu} current={current} gridSize={gridSize} />
              </Grid>
            );
          })
          .toArray()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(HeaderMenu);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderMenu.jsx